/* WhatsApp bubble (gty app): fade it out while it sits on top of the buy buttons
   ("מדדו עליי" / "הוסיפי להזמנה"), bring it back once they scroll away. */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var TARGETS = '[id*="dressapp_pdp_tryon_button"], .product--add-to-cart-button';
  var GAP = 8;
  var queued = false;

  function check() {
    queued = false;
    var host = document.querySelector('gty-whatsapp-chat-button');
    var bubble = host && host.shadowRoot && host.shadowRoot.querySelector('.gty-wacb-wrapper');
    if (!bubble) return;

    var b = bubble.getBoundingClientRect();
    var hit = false;
    document.querySelectorAll(TARGETS).forEach(function (el) {
      var t = el.getBoundingClientRect();
      if (!t.width || !t.height) return;
      if (b.left < t.right + GAP && b.right > t.left - GAP && b.top < t.bottom + GAP && b.bottom > t.top - GAP) hit = true;
    });
    host.classList.toggle('wa-bubble--hidden', hit);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(check);
  }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  // the app injects the bubble after load
  new MutationObserver(queue).observe(document.body, { childList: true });
  queue();
})();

/* Shop the style (mobile): dots under the swipeable row, so it is clear there are
   more looks to the side. The active dot follows the card at the right edge (RTL). */
(function () {
  var grid = document.querySelector('[id$="__collection_list_XVUNEL"] .collection-grid');
  if (!grid) return;
  var items = grid.querySelectorAll('.homepage-collection-grid-item');
  if (items.length < 2) return;

  var dots = document.createElement('div');
  dots.className = 'sts-dots';
  items.forEach(function (item, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', (i + 1) + ' מתוך ' + items.length);
    b.addEventListener('click', function () {
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
    dots.appendChild(b);
  });
  grid.after(dots);
  var buttons = dots.querySelectorAll('button');

  var queued = false;
  function update() {
    queued = false;
    var edge = grid.getBoundingClientRect().right;
    var best = 0;
    var bestDist = Infinity;
    items.forEach(function (item, i) {
      var d = Math.abs(item.getBoundingClientRect().right - edge);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    buttons.forEach(function (b, i) {
      b.setAttribute('aria-current', i === best ? 'true' : 'false');
    });
  }
  grid.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }, { passive: true });
  update();
})();
